export default {
    scheduled_actions_entity_name: "Nombre de la entidad",
    scheduled_actions_name: "Nombre",
    scheduled_actions_action: "Acción",
    scheduled_actions_schedule_on: "Programado en",
    scheduled_actions_executed: "Ejecutado",
    scheduled_actions_created_on: "Creado en",
    scheduled_actions_created_by: "Creado por",
    scheduled_actions_title: "Acciones programadas",
}